import MUIListItemAvatar from "@mui/material/ListItemAvatar";

export const ListItemAvatar = MUIListItemAvatar;

export default ListItemAvatar;
